
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { tabProject } from '@/types/tabList';
@Component
export default class CommonTab extends Vue {
  // 传递的是展示的数组
  @Prop() private list!: tabProject[];
  @Prop() private type!: string;
  @Prop() private tapNum!: number;
  activeIndex = 0;
  @Watch('list', { immediate: true, deep: true })
  onListChanged(newList: tabProject[]) {
    this.activeIndex = newList.findIndex((item: tabProject) => item.isActive);
  }
  @Watch('activeIndex')
  onIndexChange(newValue) {
    // 如果存在埋点字段要发送埋点
    const obj = this.list[newValue];
    if (obj.hasOwnProperty('stat')) {
      window.hxmClickStat(obj.stat);
    }
  }
  // 设置当前被激活的索引，同时
  handleTabClick(index: number) {
    this.$emit('tab-click', index);
  }

  get itemWidth() {
    const totalWidth = 100;
    const listLength = this.list.length || 1;
    const temp = totalWidth / listLength;
    return {
      bar: temp,
      slide: `${temp}%`,
      tap: `${(6.86 - (this.tapNum - 1) * 0.16) / this.tapNum}rem`,
      fit: 'fit-content',
    };
  }
  get activeBarLeft() {
    const slideWidth = this.itemWidth.bar;
    return `${this.activeIndex * slideWidth + slideWidth / 2}%`;
  }
}
